<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-mb-card tm-mb-info-card">
    <v-row>
      <v-col class="com-mb-card-contents-none-border pa-0 ml-4 mt-4" cols="11">
        <span class="com-mb-card-title">{{ title }}&nbsp;</span>
      </v-col>
    </v-row>
    <v-row>
      <span
        class="com-mb-card-contents-none-border ml-4"
        v-if="!isEmpty(selectedEvaList)"
        >{{ getDispDate(selectedEvaList[0].publishedDate)
        }}{{ text.time }}</span
      >
      <div class="tm-mb-info-card-info-area">
        <v-btn
          v-if="!isEmpty(selectedEvaList)"
          outlined
          small
          class="tm-mb-info-btn ml-2 text-issue-color"
          :issue-color="
            setEvaIssueColor(
              selectedEvaList[0].issueSort,
              selectedEvaList[0].issueLiftFlg
            )
          "
          @click="openPortal()"
        >
          <span>
            {{ setEvaIssueText(selectedEvaList[0].issueSort) }}&nbsp;{{
              selectedEvaList[0].issueLiftFlg
            }}
          </span>
          <v-icon small>open_in_new</v-icon>
        </v-btn>
      </div>
    </v-row>
    <v-row
      no-gutters
      v-if="!isEmpty(selectedEvaList)"
      class="com-mb-card-contents"
    >
      <v-col>
        <v-list
          class="pa-0 ma-0"
          v-for="(selectedEva, idx) in selectedEvaList"
          :key="`eva-${idx}`"
          dense
        >
          <v-list-group no-action v-if="!isEmpty(selectedEvaDetailList[idx])">
            <template v-slot:activator>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title class="ml-0"
                    ><span
                      class="d-block text-truncate"
                      style="max-width: 230px;"
                      >{{ selectedEvaDetailList[idx].townName }}&nbsp;{{
                        selectedEvaDetailList[idx].disasterName
                      }}</span
                    ></v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list dense>
              <v-list-item
                v-for="(item, index) in selectedEvaDetailList[idx]
                  .selectedEvaInfo"
                :key="`evaInfo-${index}`"
              >
                <v-row no-gutters class="pl-2">
                  <v-col sm="3">{{ item.title }}</v-col>
                  <v-col>
                    <div>
                      <span class="list-value">{{ item.value }}</span>
                      <span class="list-unit" v-if="item.unit">
                        {{ item.unit }}
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content no-action class="pl-2">{{
                    text.areaSubtitle
                  }}</v-list-item-content>
                </template>
                <v-list-item
                  v-for="(item, index) in selectedEvaDetailList[idx]
                    .selectedIssueList"
                  :key="`issue-${index}`"
                >
                  <v-row no-gutters class="pl-2">
                    <v-col cols="4">
                      <span
                        class="text-issue-color rp-issue mb-issue-radius"
                        :issue-color="setEvaIssueColor(item.sort, item.flag)"
                        >{{ item.title }}</span
                      >
                    </v-col>
                    <v-col cols="2"
                      ><span class="mx-1">{{ item.flag }}</span></v-col
                    >
                    <v-col cols="6">
                      <v-row
                        v-for="(areaItm, index) in item.areas"
                        :key="`area-${index}`"
                        class="pa-0 margin-clear"
                      >
                        <v-col class="pa-0 mr-2">{{ areaItm.name }}</v-col>
                        <v-col class="pa-0"
                          >{{ areaItm.house }}{{ text.unit.house }}/{{
                            areaItm.number
                          }}{{ text.unit.number }}</v-col
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list-group>
            </v-list>
          </v-list-group>
          <v-divider></v-divider>
        </v-list>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col class="tm-no-eva ml-3">
        {{ this.$store.state.app.config.messageConfig.rpNoEvacuation }}
      </v-col>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 PC用登録地点情報画面 登録観測所一覧カード
 * RpTmList.vue
 * @author LIS
 */
import WebStorage from "../../lib/webStorage.js";
import util from "./../../lib/util.js";

export default {
  name: "rp-evacuation",
  data() {
    return {
      /** 文字列リソース */
      text: {
        noData: "--",
        time: "時点",
        title: "の避難情報",
        evaSubtitle: "避難情報",
        areaSubtitle: "対象地域",
        issueSort: {
          prepare: "高齢者等避難",
          recommend: "避難勧告",
          instruct: "避難指示",
          occur: "緊急安全確保",
          area: "警戒区域",
        },
        issueLiftFlg: {
          on: "発令",
          off: "解除",
        },
        unit: {
          house: "世帯",
          number: "人",
        },
      },
      url: {
        portal: "/portal/evacuation/list/#",
      },
    };
  },
  created() {
    this.getSelectedEvaList();
  },
  props: {
    point: { type: Number, default: 0 },
  },
  computed: {
    /**取得時間パラメータ */
    tmPointEvaDatasParam: {
      get() {
        return this.$store.state.evacuation.tmPointEvaDatasParam;
      },
    },
    /**
     * 登録地点の避難情報リストを取得
     */
    selectedEvaList: {
      get() {
        return this.$store.state.evacuation.selectedEvaList;
      },
    },
    /**
     * 登録地点の避難情報詳細ファイル名リストを取得
     */
    selectedEvaDocList: {
      get() {
        return this.$store.state.evacuation.selectedEvaDocList;
      },
    },
    /**
     * 登録地点の避難情報詳細リストを取得
     */
    selectedEvaDetailList: {
      get() {
        return this.$store.state.evacuation.selectedEvaDetailList;
      },
    },
    title() {
      let info = WebStorage.getPointInfo(this.point);
      // 地点が登録されているか判定
      if (info != null && info.pointIndex != null) {
        return info.address + this.text.title;
      }
      return this.$store.state.app.config.messageConfig.rpNoRegist;
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return {
          appTime: this.$store.state.app.appTime,
          townCode: WebStorage.getPointInfo(this.point).twnCd,
          docIdList: this.$store.state.evacuation.selectedEvaDocList,
        };
      },
    },
    /**
     * 登録地点所在都道府県
     */
    prefCd: {
      get() {
        return WebStorage.getPointInfo(this.point).prefCd;
      },
    },
    kwbLink: {
      get() {
        if (location.port != 80) {
          return "http://" + location.hostname + ":" + location.port;
        } else {
          return "http://" + location.hostname;
        }
      },
    },
  },
  methods: {
    /** 登録地点の避難情報を取得 */
    getSelectedEvaList() {
      this.$store.dispatch("evacuation/getSelectedEvaList", {
        townCode: this.reqParam.townCode,
        appTime: util.formatDate(this.reqParam.appTime),
      });
    },
    /**
     * 日付を表示フォーマットに変換
     */
    getDispDate(annTime) {
      this.$log.debug("[evacuation] getDispDate(" + annTime + ")");
      if (annTime === null || annTime === "") {
        return "----/--/-- --:--";
      } else {
        return util.formatDate24(annTime, "YYYY/MM/DD HH:mm");
      }
    },
    /** 避難情報発令ボタン 着色 */
    setEvaIssueColor(sort, flag) {
      this.$log.debug("[evacuation] setEvaIssueColor(" + sort + ")");
      if (flag === "解除") {
        return "lift";
      } else if (sort === 1) {
        return "prepare";
      } else if (sort === 2) {
        return "recommend";
      } else if (sort === 3) {
        return "instruct";
      } else if (sort === 4) {
        return "occur";
      } else if (sort === 5) {
        return "area";
      } else {
        return null;
      }
    },
    /** 避難情報文言 */
    setEvaIssueText(sort) {
      this.$log.debug("[evacuation] setEvaIssueText(" + sort + ")");
      if (sort === 1) {
        return this.text.issueSort.prepare;
      } else if (sort === 2) {
        return this.text.issueSort.recommend;
      } else if (sort === 3) {
        return this.text.issueSort.instruct;
      } else if (sort === 4) {
        return this.text.issueSort.occur;
      } else if (sort === 5) {
        return this.text.issueSort.area;
      } else {
        return null;
      }
    },
    openPortal() {
      var winUrl = this.kwbLink + this.url.portal + this.prefCd;
      this.$log.debug("[rp] openPortal(" + winUrl + ")");
      var win = window.open("", "_blank");
      win.location.href = winUrl;
    },
    /**
     * リストは空かどうかの判定
     */
    isEmpty(obsList) {
      if (obsList == null) {
        return true;
      } else if (Object.keys(obsList).length == 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    /**
     * リクエストパラメータ変更時
     */
    reqParam() {
      if (
        this.reqParam.appTime != this.tmPointEvaDatasParam.dispTime ||
        this.point != parseInt(this.$route.query["pidx"], 10)
      ) {
        this.$log.debug("[rp]watch - getSelectedEvaList()");
        this.getSelectedEvaList();
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.com-mb-card-title {
  font-size: 1.2em;
  font-weight: bolder;
  color: black;
}
.tm-no-eva {
  font-size: 8pt;
}
.mb-issue-radius {
  border-radius: 4px;
  display: inline-block;
  padding: 0em 0.2em;
}
.margin-clear {
  margin-left: 0;
}
</style>
